const userPrivacyPolicy = {
  name: "userPrivacyPolicy",
  path: "/userPrivacyPolicy",
  meta: { title: "智慧脸隐私政策" },
  component: () => import("@/views/systemService/userPrivacyPolicy/index.vue")
}
export default userPrivacyPolicy
